import React, { useState, useEffect } from 'react';
import Container from '@mui/material/Container';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';
import { Paper } from '@mui/material';
import { RefreshToken } from '../components/Session';
import { useAuthDataContext } from "../components/AuthDataProvider";
import { useLocation } from "react-router";

export default function LoginPage() {
  const { user, onLogin, onLogout } = useAuthDataContext();

  const [redirectURL, setRedirectURL] = useState(null);
  const searchParams = new URLSearchParams(useLocation().search);

  const redirect = searchParams.get('redirect')
  console.log(redirect);

  useEffect(() => {
      if (!user) {
        return
      }
      RefreshToken(user.refresh_token)
      .then((result) => {
        console.log("Token refreshed");
        onLogin(result)
        console.log("on login called");
        setRedirectURL(redirect)
      }
      ).catch((error) => {
        console.log("An error occurred while refreshing token, logging out");
        console.log(error);
        onLogout()
        setRedirectURL("/login")
      }
      )}, [user, onLogin, onLogout, redirect]);

  if (redirectURL) {
      window.location.assign(redirectURL);
      return null;
  } else {
    return (
      <Container maxWidth="lg" className="container">
        <br />
        <Paper spacing={3}>

          <Grid
            container
            spacing={0}
            direction="column"
            alignItems="center"
            justify="center"
            style={{ minHeight: '25vh' }}
          >
            <Grid item xs={12} md={12} lg={12}>
              <h1>Refresh Token</h1>
            </Grid>
            <Grid item xs={12} md={12} lg={12}>
                  <CircularProgress size={48} />
            </Grid>
          </Grid>
        </Paper>
      </Container>
    )
  }

}
